import GetReferrals from '@/services/users/referralService/GetReferrals';
import PostReferral from '@/services/users/referralService/PostReferral';
import UpdateReferral from '@/services/users/referralService/UpdateReferral';

export default class ReferralService {
    /**
     * Get list of referrals.
     *
     * @returns {Promise}
     */
    getReferrals() {
        return (new GetReferrals()).handle();
    }

    /**
     * Send email and name to backend.
     *
     * @param {String} name
     * @param {String} email
     *
     * @returns {Promise}
     */
    postReferral(name, email, giftnote) {
        return (new PostReferral()).handle(name, email, giftnote);
    }

    /**
     * Update referral in backend.
     *
     * @param {Number} id
     *
     * @returns {Promise}
     */
    updateReferral(id) {
        return (new UpdateReferral()).handle(id);
    }
}
